import { render, staticRenderFns } from "./League.vue?vue&type=template&id=6551522e&scoped=true&v-if=user&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551522e",
  null
  
)

export default component.exports